// Lives in this leaf package: the floor's cross-product UI element types are structural, so nothing central imports this dimension.
import { StringsEnumDimension } from '@orus.eu/dimensions'

/**
 * Hiscox ES products
 * Source : https://www.notion.so/orus-team/Flow-questions-18f920a02bab485fa0958e4b656260dc
 */
export const esRcphProducts = [
  'MAC',
  'MAN',
  'MEDIA',
  'MISC',
  'TECH', // TECNOLOGÍA
  'GEST', // Asesorías/gestorías
  'ECO', // Industria: Actividades Relacionadas con la Construccion (ECO - Construction)
  'ENO', // Actividades No Relacionadas con Construcción (ENO - Non construction)
  'ETG', // Transporte de Mercancias / grandes dimensiones (No peligrosas) - (ETG - Transport of non dangerous goods)
] as const

export const esRcphProductDimension = new StringsEnumDimension({
  name: 'esRcphProduct',
  displayKeys: {
    name: 'dimension_name_es_rcph_product',
  },
  values: esRcphProducts,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
